import moment from 'moment-timezone'
import { DateTime } from '~/services/_utils/DateTime'
import { formats } from '~/const/global'

const dateTime = {
  computed: {
    yesterday () {
      const date = new Date()
      date.setDate(date.getDate() - 1)
      return date.toISOString()
    },
    today () {
      return this.$moment().format(formats.dateISO8601)
    },
    nowDatetime () {
      const date = new Date()
      return moment(date).format(formats.dateTimeSec)
    }
  },
  methods: {
    toTime (date) {
      return DateTime.toTime(date)
    },
    formatTime (time) {
      if (!time) { return null }
      // TODO Временное решение
      return moment(new Date(time)).tz('Europe/Kiev').format(formats.dateTime)
    },
    formatDate (date, format) {
      return DateTime.format(date, format)
    }
  }
}

export default dateTime
